"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextSlice = nextSlice;
function nextSlice(callback) {
  /* istanbul ignore next */
  Promise.resolve().then(callback);
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-menu/lib/utils/timeUtil.js
// module id = 450
// module chunks = 0